"use client"

export function WelcomeMessage() {
  return (
    <div>
      <h1 className="text-[40px] md:text-[60px] font-black uppercase leading-[0.95] tracking-[-0.04em] drop-shadow-lg">
        С океаном
        <br />
        начистоту
      </h1>

      <p className="mt-[13px] mb-[25px] text-[18px] md:mt-[18px] md:text-[24px] leading-[100%] text-white/90 drop-shadow-md">
        Узнай, как сделать океан чище
        <br />и помоги его жителям
      </p>
    </div>
  )
}
